import { Link } from "react-router-dom";

type Crumb = { label: string; to?: string };

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav className="flex items-center flex-wrap gap-1.5 text-xs md:text-sm text-foreground-500 mb-4">
      <Link to="/" className="hover:text-accent-600 transition-colors cursor-pointer">
        首页
      </Link>
      {items.map((c) => (
        <span key={c.label} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line text-base text-background-400"></i>
          {c.to ? (
            <Link to={c.to} className="hover:text-accent-600 transition-colors cursor-pointer">
              {c.label}
            </Link>
          ) : (
            <span className="text-foreground-800 font-medium">{c.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}